<template>
  <transition name="loading-fade">
    <div v-if="loadingState.isLoading" class="loading-overlay">
      <div class="loading-popup">
        <div class="loader-ring">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <h6 class="loading-title">
          {{ currentLang.loading }}
        </h6>

        <p class="loading-subtitle">
          {{ currentLang.pleaseWait }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from "vue";
import { loadingState } from "@/stores/loading";

const lang = localStorage.getItem("lang") || "fa";

const translations = {
  fa: {
    loading: "در حال بارگذاری",
    pleaseWait: "لطفاً چند لحظه صبر کنید...",
  },
  en: {
    loading: "Loading",
    pleaseWait: "Please wait a moment...",
  },
};

const currentLang = computed(() => translations[lang] || translations.fa);
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(248, 250, 252, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 20px;
}

.loading-popup {
  width: 220px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 24px;
  padding: 28px 22px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(67, 97, 238, 0.14);
  border: 1px solid rgba(67, 97, 238, 0.08);
}

.loader-ring {
  position: relative;
  width: 68px;
  height: 68px;
  margin: 0 auto 18px;
}

.loader-ring span {
  position: absolute;
  inset: 0;
  border: 4px solid transparent;
  border-top-color: #4361ee;
  border-radius: 50%;
  animation: rotate 1.2s linear infinite;
}

.loader-ring span:nth-child(1) {
  animation-duration: 1.2s;
}

.loader-ring span:nth-child(2) {
  inset: 8px;
  border-top-color: #6c8cff;
  animation-duration: 0.9s;
  animation-direction: reverse;
}

.loader-ring span:nth-child(3) {
  inset: 16px;
  border-top-color: #9db0ff;
  animation-duration: 0.7s;
}

.loading-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  color: #24324a;
}

.loading-subtitle {
  margin: 0;
  font-size: 13px;
  color: #7b8190;
  line-height: 1.7;
}

.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.25s ease;
}

.loading-fade-enter-from,
.loading-fade-leave-to {
  opacity: 0;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
